const aaa = [
	{
		path: "huoti",
		component: () => import("@/views/shuju/huoti/huotiStatistics.vue"),
		meta:{title:'活体数据'},
	},
	{
		path: "huotiItem",
		component: () => import("@/views/shuju/huoti/huotiStatisticsItem.vue"),
		meta:{title:'活体数据',keepAlive:true},
	},
	{
		path: "huotiDetail",
		component: () => import("@/views/shuju/huoti/huotiStatisticsDetail.vue"),
		meta:{title:'活体数据'},
	}
]
export default aaa;